import deviceListRu from './deviceList.ru.module.js'
import userManageRu from './userManage.ru.module.js'
import alarmPlatformRu from './alarmPlatform.ru.module.js'
import pushRecordsRu from './pushRecords.ru.module.js'
import eventTypeRu from './eventType.ru.module.js'
import faultRecordsRu from './faultRecords.ru.module.js'
import alarmRecirdsRu from './alarmRecirds.ru.module.js'
import installPointRu from './installPoint.ru.module.js'
import siteManageRu from './siteManage.ru.module.js'
import floorManageRu from './floorManage.ru.module.js'
import collectFloorManageRu from './collectFloorManage.ru.module.js'
import collectPointRu from './collectPoint.ru.module.js'
import collectSiteRu from './collectSite.ru.module.js'
import deviceProfileRu from './deviceProfile.ru.module.js'
import deviceModelRu from './deviceModel.ru.module.js'
import modelCommandRu from './modelCommand.ru.module.js'
import deviceTypeRu from './deviceType.ru.module.js'
import deviceCheckRu from './deviceCheck.ru.module.js'
import checkRecordRu from './checkRecord.ru.module.js'
import deviceImportRu from './deviceImport.ru.module.js'
import registerRecordRu from './registerRecord.ru.module.js'
import logOutRecordRu from './logOutRecord.ru.module.js'
import alarmRuleRu from './alarmRule.ru.module.js'
import linkRulesRu from './linkRules.ru.module.js'
import temporarilyUserRu from './temporarilyUser.ru.module.js'
import modelNumRu from './modelNum.ru.module.js'
import entityManageRu from './entityManage.ru.module.js'
import patrolTaskRu from './patrolTask.ru.module.js'
import patrolRecordRu from './patrolRecord.ru.module.js'
import taskTypeRu from './taskType.ru.module.js'
import patrolAllRu from './patrolAll.ru.module.js'
import menuManageRu from './menuManage.ru.module.js'
import roleManageRu from './roleManage.ru.module.js'
import exportRecordsRu from './exportRecords.ru.module.js'
import fireFightingPlatformRu from './fireFightingPlatform.ru.module.js'
import xiXiangGasPlatformRu from './xiXiangGasPlatform.ru.module.js'
import fireControlRu from './fireControl.ru.module.js'
import allRu from './all.ru.module.js'
import batchBindRu from './batchBind.ru.module.js'
import cameraSettingRu from './cameraSetting.ru.module.js'
import smartBadgeModuleRu from './smartBadgeModule.ru.module.js'
import sleepRadarRu from './sleepRadar.ru.module.js'
import fallRadarRu from './fallRadar.ru.module.js'
import payRu from './pay.ru.module.js'
import deviceDetailRu from './deviceDetail.ru.module.js'
import cameraImgRu from './cameraImg.ru.module.js'
import cameraProductRu from './cameraProduct.ru.module.js'
import otherRu from './other.ru.module.js'
import thresholdRu from './threshold.ru.module.js'

export default {
    basic: {
        // 公用
        public: {
            workbench: "Переключить рабочий стол",
            clearSear: "Очистить условия поиска",
            refresh: "Обновить таблицу",
            search: "Поиск",
            // 单位
            entitySearch: "Поиск по названию организации",
            entityID: "ID организации",
            entityName: "Название организации",
            entityAddr: "Адрес организации",
            // 下拉tble框中的场所
            siteID: "ID объекта",
            siteName: "Название объекта",
            other: "Адрес объекта",
            siteSearchPla: "Введите название объекта",
            // 下拉tble框中的类型
            typeSearch: "Введите название типа",
            typeID: "ID типа",
            typeName: "Название типа",
            typeOther: "Код типа",
            typeTitle: "Тип устройства",
            // 型号
            modelSearch: "Введите название модели",
            modelID: "ID модели",
            modelName: "Название модели",
            modelOther: "Код модели",
            // 模型
            Two_modelSearch: "Введите название модели",
            Two_modelID: "ID модели",
            Two_modelName: "Название модели",
            Two_modelOther: "Время создания",

            Unblock: "Отменить блокировку",
            sureUnblock: "Вы уверены, что хотите отменить блокировку тревоги?",

            // 操作
            details: "Подробности",
            controls: "Операция",
            confirmBtn: "Подтвердить",
            cancel: "Отмена",
            confirmNospace: "Подтвердить",
            cancelNospace: "Отмена",
            controls_collect: "Избранное",
            cancelOperation: "Отменить операцию",
            addBtn: "Добавить",
            delete: "Удалить",

            //  规则
            rulesSpace: "Ввод не может содержать пробелы",
            rule_entityNospace: "ID организации не может быть пустым",
            basicInformation: "Базовая информация",

            open: "Включить",
            close: "Выключить",
            closeSpace: "Закрыть",
            Time_midden: "по",
            Time_start: "Дата начала",
            Time_end: "Дата окончания",
            create_date: "Дата создания",
            MobilePhone: "Мобильный телефон",
            sendingTime: "Время отправки",
            eventType: "Тип события",
            deviceCoding: "Код устройства",
            installAddr: "Место установки",
            alarmTypeName: "Название типа тревоги",
            alarmReason: "Причина тревоги",
            alarmTiem: "Время тревоги",
            searchDeviceCoding: "Введите полный код устройства",
            moreSear: "Расширенный поиск",
            owner: "Владелец",
            owner_phone: "Телефон",
            alarm_type: "Тип тревоги",
            select_all: "Все",
            select_Install: "Установлено",
            select_uninstalled: "Не установлено",
            Date: "Дата",
            Time: "Время",
            file: "Файл",
            number: "Номер",
            saveBtn: "Сохранить",
            select: "Выбрать",
            table_pointId: "ID точки",
            table_pointNameSearchPla: "Поиск по названию точки",
            inputPlaShort: "Введите",
            pleaseSelectShort: "Выберите",
            emptyNoData: "Нет данных",
            btn_toggleChart: "Показать график",
            btn_closeChart: "Скрыть график",
            btn_tempSetting: "Настройка температуры",
            btn_humiditySetting: "Настройка влажности",
            btn_heartbeatTimeSetting: "Интервал heartbeat",
            gas_desc_status: "Статус",
            gas_desc_range: "Диапазон",
            gas_desc_highAlarm: "Верхний порог",
            gas_desc_lowAlarm: "Нижний порог",
            camera: "Камера",
            otherDevice: "Другое устройство",
            industrial_equipment: "Промышленное оборудование",
            household_equipment: "Бытовое оборудование",
            bigTypeBack: "Назад к категориям",
            rule_content: "Содержимое правила",
            rule_data: "Данные правила",

            notAllowBatch: "Массовое удаление не допускается!",

            //messageAll
            message_addSucce: "Добавление прошло успешно!",
            message_addLose: "Не удалось добавить!",
            messageAllClear: "Все условия поиска очищены!",
            messageAllRefresh: "Успешно обновлено!",
            messageAllSear: "Поиск выполнен успешно!",
            message_collectSucc: "Успешно добавлено в избранное!",
            message_collectLose: "Не удалось добавить в избранное!",
            message_importSucc: "Экспорт данных выполнен успешно!",
            message_importLose: "Ошибка экспорта данных!",
            message_importRule: "Пожалуйста, сначала выберите данные для экспорта",
            message_deleteImgSucc: "Изображение успешно удалено!",
            message_deleteImgLose: "Не удалось удалить изображение!",
            message_ImgUpSucc: "Загрузка прошла успешно!",
            message_ImgUpLose: "Ошибка загрузки!",
            message_editSucc: "Изменения успешно сохранены!",
            message_editLose: "Не удалось сохранить изменения!",
            message_addDataSucc: "Добавление прошло успешно!",
            message_addDataLose: "Не удалось добавить данные!",
            message_deleteSucc: "Удаление прошло успешно!",
            message_deleteLose: "Не удалось удалить!",
            message_exceedMaxImg: "Ошибка загрузки! Можно загрузить только одно изображение",

            // 文件
            file_btnAdd: "Нажмите для загрузки",
            file_attachmentAdd: "Загрузка вложений",
            file_isUpIMg: "Подтвердить загрузку этого изображения?",
            file_Tips: "Подсказка",

            // 表格
            derive: "Экспорт",
            deriveTips: "Подтвердить экспорт этих данных?",
            table_createdTime: "Время создания",
            table_entity: "Организация",
            table_deviceType: "Тип устройства",
            table_OwnersName: "Имя владельца",
            table_OwnerTelephone: "Телефон владельца",
            table_installationPersonnel: "Монтажник",
            table_pointName: "Название точки",
            table_longitude: "Долгота",
            table_latitude: "Широта",
            table_pointAddr: "Адрес точки",
            table_region: "Регион",
            table_UpTime: "Время отправки",
            table_informant: "Сообщивший",
            table_faultTime: "Время неисправности",
            table_faultDesc: "Описание неисправности",
            table_FaultCause: "Причина неисправности",
            table_handleMan: "Обработал",
            table_handleTime: "Время обработки",
            table_handleSuggestion: "Описание обработки",
            table_handleSummary: "Запись обработки",
            table_faultReportSummary: "Сведения о заявке и обработке",
            table_entityName: "Название организации",
            table_relevanceDevice: "Связанное устройство",
            table_alarmRulesEntity: "Уровень организации",
            table_alarmRulesDevice: "Уровень устройства",
            table_alarmRulesEvent: "Тип события",
            table_alarmRulesIsOpen: "Включено/выключено",
            table_alarmRulesRadius: "Радиус оповещения",

            table_deviceModel: "Модель устройства",
            table_deviceState: "Состояние устройства",
            table_deviceLatelyTime: "Время последней активности",
        },
        // 搜索的内容
        search: {
            sitePla: "Пожалуйста, введите название объекта",
            typePla: "Пожалуйста, введите название типа",
            deviceCodePla: "Пожалуйста, введите полный код устройства",
            ownerPla: "Пожалуйста, введите имя владельца",
            ownerPhonePla: "Пожалуйста, введите телефон владельца",
            search: "Поиск",
            searchNoMore: "Больше нет данных",
            isLoading: "Загрузка...",
            noCorrectPhone: "Неверный формат номера телефона",
        },
        // 省市县组件
        region: {
            city: "Пожалуйста, выберите провинцию",
            county: "Пожалуйста, выберите провинцию или город",
            provincePla: "Пожалуйста, выберите провинцию",
            cityPla: "Пожалуйста, выберите город",
            countyPla: "Пожалуйста, выберите район",
        },
        // 应用中心
        ApplicationCenterPage: {
            title: "Центр приложений",
            logOut: "Выход",
            backStage: "Панель управления",
            NumScreen: "Цифровой большой экран",
            alarmPlatform: "Платформа приема тревог",
            patrol: "Патрулирование и инспекция",
            production: "Управление производством",
            childPlatform: "Подплатформа",
            logOutTips: "Вы уверены, что хотите выйти из системы?",
            chilListFiren: "Платформа умного пожаротушения",
            chilListGas: "Платформа газа Сишян",
            chilListGasB: "Универсальная газовая платформа",
            yes: "Хорошо",
            cancel: "Отмена",
            closeAlarmMute: "Выключить звуковой сигнал тревоги",
            bgSet: "Настройка фона",
            bgImg: "Фоновое изображение",
            bgColor: "Цвет фона:",
            def: "По умолчанию",
            personSet: "Персональные настройки",
            bgMenuColor: "Цвет фона меню",
            textMenuColor: "Цвет текста меню",
            acMenuTextCol: "Цвет текста активного меню",
            hovBgColor: "Цвет фона при наведении",
            hovTextCOlor: "Цвет текста при наведении",
            acMenuBgColor: "Цвет фона активного меню",
            initSet: "Сброс настроек",
            nav_largeDataScreen: "Большой экран данных",
        },
        // 登录页面
        newLogin: {
            title: "Интеллектуальная облачная платформа безопасности",
            login: "Вход",
            userPla: "Пожалуйста, введите учетную запись",
            userRules: "Учетная запись не может быть пустой",
            passwordPla: "Пожалуйста, введите пароль",
            passwordRules: "Пароль не может быть пустым",
            passwordRulesLength: "Длина не должна быть меньше 6 символов",
            platformTitle: "Система управления безопасностью",
            loginSucc: "Вход выполнен успешно!",
            loginLose: "Имя пользователя не существует или неверный пароль!",
            successText: "Проверка пройдена!",
            failText: "Проверка не пройдена, попробуйте снова",
            sliderText: "Перетащите ползунок, чтобы завершить пазл",
        },
        // 导航栏
        menubar: {
            workbench: "Рабочий стол",
            moreHelp: "Онлайн-документация",
            backstageHomePaee: "Главная страница панели",
            cancel: "Отмена",
            logOut: "Вы уверены, что хотите выйти из системы?",
            backstageManage: "Управление панелью",
            SwitchLanguage: "Смена языка",
            equipped: "Есть устройства",
            AllEquipment: "Все устройства",
        },
        // 数字大屏
        digitalPage: {
            title: "Панель управления",

            deviceTitle: "Статистика устройств",
            deviceAllNum: "Общее количество устройств",
            deviceOnLine: "Онлайн-устройства",
            deviceOffLIne: "Офлайн-устройства",
            deviceInstall: "Установленные устройства",
            deviceNoInstall: "Неустановленные устройства",
            leftMiddenTilt: "Учет устройств",
            leftMiddenNum: "Количество",
            leftMiddenpercent: "Процент",

            leftBottomTitle: "Статистика типов устройств",
            leftBottomDevice: "Устройства",

            middenTop_todayAlarm: "Сегодняшние вызовы",
            middenTop_fault: "Сегодняшняя обработка",
            middenTop_install: "Сегодня установлено",
            middenTop_maintenance: "Сегодня обслуживание",

            middenTop_todayAlarm1: "Сегодняшние тревоги",
            middenTop_fault1: "Сегодняшние неисправности",
            middenTop_install1: "Сегодня установки",
            middenTop_maintenance1: "Сегодня обслуживание",

            middenMap_owenr: "Информация о владельце",
            middenMap_owenrPhone: "Телефон владельца",
            middenMap_addr: "Адрес объекта",
            middenMap_siteName: "Название объекта",
            middenMap_siteDeviceNum: "Общее количество устройств на объекте",
            middenMap_floorNum: "Количество этажей",
            middenMap_dilogTitle: "Список точек",
            enterCorrectFloor: "Пожалуйста, введите корректный этаж",
            middenMap_dialog_owenrName: "Имя владельца",
            middenMap_dialog_owenrPhone: "Телефон владельца",
            middenMap_dialog_siteName: "Название объекта",
            middenMap_dialog_siteAddr: "Адрес объекта",

            middenBottom_entity: "Управление организациями",
            middenBottom_jianzhu: "Здание",
            middenBottom_device: "Устройство",
            middenBottom_user: "Пользователь",
            middenBottom_sys: "Настройки",
            screen_styleTheme: "Стиль оформления",

            rightTop_alarm: "Тревога",
            warning: "Предупреждение",
            rightTop_fault: "Неисправность",

            rightMidden_title: "Статистика состояния устройств",
            rightMidden_offline: "Офлайн",
            rightMidden_tamperd: "Демонтаж",
            rightMidden_highTemperature: "Высокая температура",
            rightMidden_low_signal: "Слабый сигнал",
            rightMidden_lowBattery: "Низкое напряжение",
            rightMidden_fault: "Неисправность датчика",
            rightMidden_alarm: "Тревога",
            feifa_disassemble: "Незаконный демонтаж",
            rengong_fault: "Ручное обслуживание",
            rightBottom_alarmAddr: "Адрес тревоги",
            rightBottom_deviceNum: "Код устройства",
            rightBottom_alarmType: "Тип тревоги",

            dialog_entityTitle: "Управление организациями",
            dialog_entitySear: "Пожалуйста, выберите организацию",
            dialog_entityName: "Организация",
            dialog_entityAddr: "Адрес организации",
            dialog_entityPlatformName: "Название платформы",
            dialog_entityGo: "Просмотр устройств",

            dialog_siteTitle: "Список зданий",
            dialog_siteSearName: "Пожалуйста, введите название объекта",
            dialog_siteAddrSear: "Пожалуйста, введите адрес объекта",
            dialog_siteAddr: "Адрес объекта",
            dialog_siteName: "Название объекта",
            dialog_siteEntityName: "Организация",
            dialog_siteRegion: "Регион",

            dialog_deviceNum: "Пожалуйста, введите полный код устройства",
            dialog_deviceState: "Пожалуйста, выберите состояние устройства",
            dialog_deviceOrder: "Команда",
            dialog_deviceNumTable: "Код устройства",
            dialog_deviceEntity: "Организация",
            dialog_deviceType: "Тип устройства",
            dialog_deviceInstallAddr: "Место установки",
            dialog_deviceTypetwo: "Модель устройства",
            dialog_deviceStateTable: "Состояние устройства",
            dialog_deviceEventsTime: "Время последней активности",

            dialog_userTitle: "Список пользователей",
            dialog_userLoginName: "Пожалуйста, введите учетную запись",
            dialog_userNameSear: "Пожалуйста, введите имя",
            dialog_userPhoneSear: "Пожалуйста, введите номер телефона",
            dialog_userEntityTitle: "Организация",
            dialog_userEntityName: "Организация",
            dialog_userPhone: "Телефон",
            dialog_userSex: "Пол",
            dialog_userMan: "Мужчина",
            dialog_userWoMan: "Женщина",
            dialog_userloginTable: "Учетная запись",
            dialog_userJurisdiction: "Права",
            dialog_userName: "Имя пользователя",
            dialog_userDeatil: "Просмотр деталей пользователя",
            dialog_userDeatilBasice: "Основная информация",
            dialog_userDeatilBtn: "Подтвердить изменения",

            dialog_SettingTitle: "Настройки",
            dialog_SettingBackdrop: "Фон",
            dialog_SettingNormal: "Стандартный цвет",
            dialog_SettingDarkblue: "Глубокий синий",
            dialog_Settingblue: "Индиго",
            dialog_SettingGrey: "Элегантный серый",
            dialog_SettingDark: "Фантомный черный",
            dialog_SettingLight: "Лунное серебро",

            dialog_deviceListTitle: "Список устройств",
            userNamMax10: "Имя пользователя не может превышать 10 символов",
            alarmTypeAnalysis: "Анализ типов тревог",
            snapshotAnalysis: "Анализ снимков",
            timeRange: "Диапазон времени",
            selectDataRange: "Выберите диапазон данных",
            recentThreeDays: "Последние 3 дня",
            threeDays: "3 дня",
            thisWeek: "Эта неделя",
            thisMonth: "Этот месяц",
            alarmSign: "Метка тревоги",
            alarmDesc: "Описание тревоги",
            alarmCount: "Количество тревог",
            event: "Событие",
            code: "Код",
            menuDataScreen: "Экран данных",
            menuDeviceList: "Список устройств",
            menuAlarmRecord: "Журнал тревог",
            menuUntreatedAlarm: "Необработанные тревоги",
            menuImageRecord: "Журнал изображений",
            locationType: "Тип местоположения",
            statusLag: "Задержка",
            alarm_water: "Тревога затопления",
            alarm_manhole: "Тревога смещения люка",
            alarm_smoke: "Тревога дыма",
            alarm_co: "Тревога CO",
            alarm_gas: "Тревога горючего газа",
            alarm_remove: "Демонтаж устройства",
            alarm_highTemp: "Тревога высокой температуры",
            alarm_humidity: "Тревога влажности",
            alarm_infrared: "Инфракрасная тревога",
            alarm_reset: "Сброс",
            alarm_wakeup: "Ручное пробуждение",
            alarm_gps: "GPS-позиционирование",
            alarm_concentration: "Тревога концентрации",
            alarm_displace: "Тревога смещения",
        },
        deviceList: deviceListRu,
        userManage: userManageRu,
        alarmPlatform: alarmPlatformRu,
        pushRecords: pushRecordsRu,
        eventType: eventTypeRu,
        faultRecords: faultRecordsRu,
        alarmRecirds: alarmRecirdsRu,
        installPoint: installPointRu,
        siteManage: siteManageRu,
        floorManage: floorManageRu,
        collectFloorManage: collectFloorManageRu,
        collectPoint: collectPointRu,
        collectSite: collectSiteRu,
        deviceProfile: deviceProfileRu,
        deviceModel: deviceModelRu,
        modelCommand: modelCommandRu,
        deviceType: deviceTypeRu,
        deviceCheck: deviceCheckRu,
        checkRecord: checkRecordRu,
        deviceImport: deviceImportRu,
        registerRecord: registerRecordRu,
        logOutRecord: logOutRecordRu,
        alarmRule: alarmRuleRu,
        linkRules: linkRulesRu,
        temporarilyUser: temporarilyUserRu,
        modelNum: modelNumRu,
        entityManage: entityManageRu,
        patrolTask: patrolTaskRu,
        patrolRecord: patrolRecordRu,
        taskType: taskTypeRu,
        patrolAll: patrolAllRu,
        menuManage: menuManageRu,
        roleManage: roleManageRu,
        exportRecords: exportRecordsRu,
        fireFightingPlatform: fireFightingPlatformRu,
        xiXiangGasPlatform: xiXiangGasPlatformRu,
        fireControl: fireControlRu,
        all: allRu,
        batchBind: batchBindRu,
    },
    mqttConnect: {
        // "success": "success",
        success: "Статус подключения: подключение успешно",
        fail: "Статус подключения: подключение не удалось",
    },
    cameraSetting: cameraSettingRu,
    smartBadgeModule: smartBadgeModuleRu,
    sleepRadar: sleepRadarRu,
    fallRadar: fallRadarRu,
    pay: payRu,
    deviceDetail: deviceDetailRu,
    cameraImg: cameraImgRu,
    cameraProduct: cameraProductRu,
    other: otherRu,
    threshold: thresholdRu,
}
